import type { ServerWithTest } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'
import { createContext, type FC } from 'react'

type Operation = {
  component: FC | null
  batchTypes: readonly string[]
}
export type OperationsContext = {
  generatedOperations: Record<ServerWithTest, Operation>
  build: {
    buildNo: string
    buildTime?: string
  }
  activeComponent: ServerWithTest | undefined
  onChangeActiveComponent: (component: ServerWithTest) => void
}

const OperationsContext = createContext<OperationsContext | null>(null)

const [useOperationsContext, Provider] =
  createRequiredContext<OperationsContext>('Operations')

export { Provider, useOperationsContext }
